import React from "react";
import { Input } from "semantic-ui-react";

const JsonApiUrlInput = (props: { url: string }) => <div className="margin-bottom-mini">
  <Input
    action={{
      color: "blue",
      icon: "globe",
      onClick: (e) => {
        e.preventDefault();
        window.open(props.url, "_blank");
      }
    }}
    fluid
    value={props.url}
  />
</div>;

export default JsonApiUrlInput;